import { Colors } from '../../theme';
import { textStyles } from '../../theme/fonts-ppv';

export default {
    paginationSection: {
        display: 'flex'
    },
    paginationContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 24,
    },
    paginationResults: {
        ...textStyles.body3,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: Colors.grey400
    },
    paginationRange: {
        color: '#1F2040',
        marginRight: 16,
    },
    paginationSelect: {
        width: 62,
    },
    paginationArrows: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    paginationArrow: {
        width: 24,
        height: 24,
        borderRadius: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        color: '#1D2055',
        backgroundColor: 'transparent',
    },
    paginationArrowDisabled: {
        cursor: 'default',
        opacity: 0.3,
    },
}